module.exports = __webpack_public_path__ + "media/images/logo-md-0e0bf8019f3338751d74cf48797037b7.png";